<template>
    <foreignObject
        :x="box.x"
        :y="box.y"
        :width="box.width"
        :height="box.height"
        style="position: relative"
    >
        <div style="width: 100%; height: 100%; overflow-y: auto" class="scrollbar-hidden">
            <div v-if="!preview" style="position: absolute; top: 10px; right: 10px; z-index: 10">
                <BoxPopupMenu :box="box" :hideOptions="hideMenuOptions" />
            </div>
            <!-- <template v-if="isComponent"> -->
            <component :is="tag" v-bind="props" :box="box" :container="box" :preview="preview" />
            <!-- </template> -->
            <!-- <template v-if="type === 'basic'">
                <TextField :box="box"></TextField>
            </template> -->
        </div>
    </foreignObject>
</template>
<script lang="ts">
import { Box, ComponentBoxModel, SimpleContainer } from "./models";
import CompanyStatusBoard from "../CompanyStatusBoard.vue";
import CardAmount from "../CardAmount.vue";
import TextField from "./components/TextField.vue";
import Indicator from "./components/Indicator.vue";
import CardRatio from "../CardRatio.vue";
import AccountingResults from "./components/AccountingResults.vue";
import BoxPopupMenu from "./BoxPopupMenu.vue";
import RatioIndicator from "./components/RatioIndicator.vue";
import Title from "./components/Title.vue";
import GridBox from "./components/GridBox.vue";
import { Prop } from "vue-facing-decorator";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component({
    components: {
        CompanyStatusBoard,
        CardAmount,
        TextField,
        Indicator,
        CardRatio,
        AccountingResults,
        BoxPopupMenu,
        RatioIndicator,
        Title,
        GridBox,
        // SimpleContainer
        // Home,
        // CashFlowPlan,
        // BoxComponent
    },
})
export class CustomForeignObject extends Vue {
    @Prop() box: ComponentBoxModel;
    @Prop({ default: false }) preview: boolean;
    @Prop({ default: null }) hideMenuOptions: string[];

    get type() {
        // "basic" | "component" | "widget"
        return this.box?.type;
    }

    get tag() {
        return this.box?.tag;
    }

    get props() {
        return this.box?.props ?? {};
    }

    get isComponent() {
        return this.type === "component" && this.tag;
    }
}

export default toNative(CustomForeignObject);
</script>
<style lang="css" scoped>
.scrollbar-hidden::-webkit-scrollbar {
    overflow: auto;
    display: none;
    width: 12px;
}

.scrollbar-hidden {
    overflow: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
}
</style>
